import React from 'react';
import type { RouteComponentProps } from 'react-router-dom';

type QuizPage = React.ComponentType<RouteComponentProps>;

/**
 * `/b/<token>` (保障小測驗) and `/r/<token>` (招募測驗) — the invitation links
 * (store/clientQuiz quizLinkOf). The quiz is played right here rather than
 * redirected to a longer page URL, so the address bar keeps the short link the
 * client was sent. The page reads its token as `?t=`, so that is what it is handed.
 */
const ShortQuizLink = (props: RouteComponentProps<{ token: string }> & { page: QuizPage }) => {
  const { page: Page, ...route } = props;
  const token = route.match.params.token || '';
  return <Page {...route} location={{ ...route.location, search: `?t=${encodeURIComponent(token)}` }} />;
};

export default ShortQuizLink;
